module.exports = __webpack_public_path__ + "img/loading.314c51a4.gif";